export default "__VITE_ASSET__CXNnfvh1__"